import { TranslocoPipe } from '@jsverse/transloco';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { ButtonComponent, IconComponent } from 'vcp-common-ui-lib';

@Component({
    selector: 'vc-reorder-button',
    imports: [TranslocoPipe, ButtonComponent, IconComponent],
    templateUrl: './reorder-button.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrl: './reorder-button.component.scss',
})
export class ReorderButtonComponent {
    @Input()
    disabled: boolean = false;

    @Input()
    tooltip!: string;

    @Output()
    trigger: EventEmitter<void> = new EventEmitter<void>();
}
